module.exports = __webpack_public_path__ + "static/iron_defender-d6467978c10e26f0442b07cb308ae445.png";